const authHeader = () => {
  var root = JSON.parse(localStorage.getItem('persist:root'));
  var user = null;
  var subsite = null;
  if(root != null && root.auth != null) {
    var auth = JSON.parse(root.auth);
    user = auth.user;
    subsite = auth.currentSubsite;
    console.log("SUBSITE IN AUTH", auth, subsite, user);
  }
  if(user && user !== undefined && user !== "undefined" && user.username) {
    if (user && user.accessToken) {
      return { "x-access-token" :user.accessToken, "subsite-id": subsite.id};
    } 
  } else if(subsite) {
      return { "subsite-id": subsite.id};
  } else {
    console.log("SUBSITE NOT SET");
    return {"subsite-id": -1};
  }
}

const authHeaderFromState = (theState) => {
  console.log("STATE", theState);
  if(theState.auth) {
    var user = theState.auth.user;
    var subsite = theState.auth.currentSubsite;

    if(user && user !== undefined && user !== "undefined" && user.username) {
      if (user && user.accessToken) {
        return { "x-access-token" :user.accessToken, "subsite-id": subsite.id};
      } else {
        return {"subsite-id": 1};
      }
    } else if(subsite) {
      return { "subsite-id": subsite.id};
    } else {
      return {"subsite-id": 1};
    }
  } else {
    return {"subsite-id": 1};
  }
}


const AuthHeader = {
  authHeader,
  authHeaderFromState
};
export default AuthHeader;
